/**
 * Simply remove the no-js classname from the document body
 */
export const tabsBlock = () => {
	const tab = document.querySelector('.tabs');
	if (!(tab instanceof window.HTMLElement)) {
		return;
	}

	const tabButtons = tab.querySelectorAll('[role="tab"]');
	const tabPanels = Array.from(tab.querySelectorAll('[role="tabpanel"]'));

	function tabClickHandler(e) {
		//Hide All Tabpane
		tabPanels.forEach((panel) => {
			panel.classList.remove('active');
			panel.classList.add('hidden');
		});

		//Deselect Tab Button
		tabButtons.forEach((button) => {
			button.setAttribute('aria-selected', 'false');
		});

		//Mark New Tab
		e.currentTarget.setAttribute('aria-selected', 'true');

		//Show New Tab
		const { id } = e.currentTarget;

		const currentTab = tabPanels.find(
			(panel) => panel.getAttribute('aria-labelledby') === id
		);

		currentTab.classList.add('active');
		currentTab.classList.remove('hidden');
	}

	tabButtons.forEach((button) => {
		button.addEventListener('click', tabClickHandler);
	});
};
